import React, { ReactChild } from 'react'
import _cx from 'classnames/bind'
import Text from '../text'
import cls from './styles.scss'
import { AutomationTarget } from '../../../../src/types'
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
const cx = _cx.bind(cls)

type BadgeMode =
  | 'info'
  | 'warn'
  | 'alert'
  | 'success'
  | 'error'
  | 'purple'
  | 'gray'
  | 'default'

export interface BadgeProps extends AutomationTarget {
  primary?: ReactChild
  secondary?: ReactChild
  flashing?: boolean
  leftSectionProps?: object
  rightSectionProps?: object
  mode?: BadgeMode
  className?: string
  size?: 'small' | 'medium'
}

const Badge = ({
  primary = '',
  secondary = '',
  flashing = false,
  mode = 'default',
  elmId = '',
  className = '',
  size = 'medium',
}: BadgeProps) => {
  return (
    <div className={cx('container', size, className)} data-elm-id={elmId}>
      <span
        className={cx(
          'inline',
          { 'animate-grow': secondary },
          secondary ? 'is-open' : 'is-closed'
        )}
      >
        {primary && (
          <Text
            data-elm-id={`${elmId}-primary`}
            weight='heavy'
            color='white'
            className={cx('pill', size, { flashing }, `type-${mode}`, {
              'no-right-border-radius': secondary,
            })}
          >
            {primary}
          </Text>
        )}
        {secondary && (
          <Text
            data-elm-id={`${elmId}-secondary`}
            weight='heavy'
            className={cx(
              'pill',
              size,
              'invert-colors',
              { 'invert-flashing': flashing },
              { [`type-${mode}`]: !flashing },
              { 'no-left-border-radius': primary }
            )}
          >
            {secondary}
          </Text>
        )}
      </span>
    </div>
  )
}

export default Badge
